import React, { useEffect } from 'react'
import SideMenu from '../../components/sandbox/SideMenu'
import TopHeader from '../../components/sandbox/TopHeader'
import NProgress from 'nprogress'
// import 'nprogress/nprogress.css'

import { Layout, theme } from 'antd';
import './NewSandBox.css'
import PageRouter from '../../components/sandbox/PageRouter'

const { Content } = Layout;

export default function NewsSandBox() {
  NProgress.start();
  useEffect(()=>{
    NProgress.done()
  },[])
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  return (
    <Layout>
      <SideMenu></SideMenu>
      <Layout>
        <TopHeader></TopHeader>
        <Content
          style={{
            margin: '12px 12px',
            padding: 24,
            minHeight: 280,
            overflow: "auto",
            background: colorBgContainer,
          }}
        >
          <PageRouter></PageRouter>
        </Content>
      </Layout>
    </Layout>
  )
}
